// Thème jour, nuit ou système : appliqué sans scintillement (script en tête de page lisant le cache local),
// persistant côté serveur (préférences) et en cache local. Critère R-11.

import type { Theme } from '@carburanttrack/shared';

export const CLE_CACHE_THEME = 'ct-theme';
export const CLE_CACHE_DENSITE = 'ct-densite';

export function themeEffectif(preference: Theme, sombreSysteme: boolean): 'jour' | 'nuit' {
  if (preference === 'systeme') return sombreSysteme ? 'nuit' : 'jour';
  return preference;
}

function systemeSombre(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia('(prefers-color-scheme: dark)').matches
    : false;
}

export function lireThemeCache(): Theme {
  try {
    const v = localStorage.getItem(CLE_CACHE_THEME);
    return v === 'jour' || v === 'nuit' || v === 'systeme' ? v : 'systeme';
  } catch {
    return 'systeme';
  }
}

/** Applique le thème au document et le conserve en cache local. */
export function appliquerTheme(preference: Theme): 'jour' | 'nuit' {
  const effectif = themeEffectif(preference, systemeSombre());
  document.documentElement.dataset.theme = effectif;
  document.documentElement.dataset.preferenceTheme = preference;
  try {
    localStorage.setItem(CLE_CACHE_THEME, preference);
  } catch {
    // Stockage local indisponible : le thème reste appliqué pour la session.
  }
  const meta = document.querySelector('meta[name="theme-color"]');
  meta?.setAttribute('content', effectif === 'nuit' ? '#0b1a33' : '#0b2a5b');
  return effectif;
}

export const CLE_CACHE_TAILLE = 'ct-taille';

/** Taille du texte (D-038 : petite, normale, grande), appliquée à la racine et conservée en cache local. */
export function appliquerTaille(taille: 'petite' | 'normale' | 'grande'): void {
  document.documentElement.dataset.taille = taille;
  try {
    localStorage.setItem(CLE_CACHE_TAILLE, taille);
  } catch {
    // Sans conséquence.
  }
}

export function appliquerDensite(densite: 'confortable' | 'compacte'): void {
  document.documentElement.dataset.densite = densite;
  try {
    localStorage.setItem(CLE_CACHE_DENSITE, densite);
  } catch {
    // Sans conséquence.
  }
}

/** Suit les changements du thème système lorsque la préférence est « système ». */
export function suivreThemeSysteme(): () => void {
  if (typeof window.matchMedia !== 'function') return () => undefined;
  const requete = window.matchMedia('(prefers-color-scheme: dark)');
  const ecouteur = () => {
    if (lireThemeCache() === 'systeme') appliquerTheme('systeme');
  };
  requete.addEventListener('change', ecouteur);
  return () => requete.removeEventListener('change', ecouteur);
}
